<template>
  <div class="share-bar">
    <div class="share-bar__inner">
      <div class="share-bar__text">
        <p class="share-bar__title">GoTrustJP</p>
        <p class="share-bar__sub">打开 App 查看完整内容</p>
      </div>
      <button type="button" class="share-bar__btn" @click="$emit('open-app')">
        打开 App
      </button>
    </div>
  </div>
</template>

<script>
export default {
  name: 'ShareBottomBar',
  emits: ['open-app'],
}
</script>

<style scoped>
.share-bar {
  position: fixed;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: 100;
  padding: 12px 16px calc(12px + env(safe-area-inset-bottom));
  background: rgba(255, 255, 255, 0.96);
  border-top: 1px solid var(--color-border);
  backdrop-filter: blur(8px);
}

.share-bar__inner {
  max-width: 560px;
  margin: 0 auto;
  display: flex;
  align-items: center;
  gap: 12px;
}

.share-bar__text {
  flex: 1;
  min-width: 0;
}

.share-bar__title {
  font-size: 15px;
  font-weight: 700;
  color: var(--color-text);
  line-height: 1.3;
}

.share-bar__sub {
  margin-top: 2px;
  font-size: 12px;
  color: var(--color-text-secondary);
}

.share-bar__btn {
  flex-shrink: 0;
  height: 40px;
  padding: 0 18px;
  border-radius: 20px;
  background: var(--color-accent);
  color: #fff;
  font-size: 14px;
  font-weight: 600;
}

.share-bar__btn:hover {
  background: var(--color-accent-hover);
}
</style>
